import { C } from "../../lib/constants";

export const Chip = ({text, color=C.accent, small=false}) => (
  <span style={{background:`${color}15`,color,border:`1px solid ${color}30`,borderRadius:20,padding:small?"2px 8px":"4px 12px",fontSize:small?9:11,fontWeight:700,whiteSpace:"nowrap"}}>{text}</span>
);
